import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { GuidedWorkflowsMenuModule } from 'GuidedWorkflowsApp/ts/features/guided-workflows-menu/guided-workflows-menu.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { BackgroundJobsProgressPopoverModule } from 'NotificationsApp/ts/features/background-jobs-progress-popover/background-jobs-progress-popover.module';
import { NotificationsSideMenuModule } from 'NotificationsApp/ts/features/notifications-side-menu/notifications-side-menu.module';
import { QuickflowsMenuModule } from 'QuickflowsApp/ts/features/quickflows-menu/quickflows-menu.module';
import { AgentSidePanelComponent } from 'AgentApp/ts/features/agent/components/agent-side-panel/agent-side-panel.component';
import { SideMenuToastMessagesComponent } from 'NewAngular/features/components/toast-messages/side-menu-toast-messages.component';
import * as i0 from "@angular/core";
export class SideMenuModule {
}
SideMenuModule.ɵfac = function SideMenuModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuModule)(); };
SideMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SideMenuModule });
SideMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        QuickflowsMenuModule,
        GuidedWorkflowsMenuModule,
        IconModule,
        TooltipModule,
        AgentSidePanelComponent,
        DragDropModule,
        NotificationsSideMenuModule,
        BackgroundJobsProgressPopoverModule,
        SideMenuToastMessagesComponent] });
